require('./bootstrap');

// require('dropzone/dist/dropzone')
import $ from 'jquery';

// import Sortable from 'sortablejs';

window.$ = window.jQuery = $;
